<template>
</template>

<script>
	import { wclient } from '../../static/wclient-mobile.js'
	export default {
		name: 'Loading',
		data() {
			return {
				baseUrl: "",
				to: ""
			}
		},
		methods: {

		},
		mounted() {
			var that = this;
			var publicUrl = window.location.hostname;
			if(publicUrl == "localhost") {
				var baseUrl = "https://www.xiangshan1949.cn";
			} else if(publicUrl == "m.xs.weapi.org") {
				var baseUrl = "https://www.xiangshan1949.cn";
			} else {
				var baseUrl = "https://www.xiangshan1949.cn";
			}
			that.baseUrl = baseUrl;
			wclient.view.showLoading();
			that.to = sessionStorage.getItem('to')
			wclient.crossdomain = true; // 启动跨域支持（多模块组合应用）
			wclient.ajax({
				type: "POST",
				url: that.baseUrl + "/tickets/tickets/ajax?ugi=loginUgi&action=loginInfo",
				dataType: "json",
				async: true,
				data: {

				},
				success: function(data) {
					wclient.view.hideLoading();
					if(data.code == 'A00006') {
						if(data.loginType == 'personalLogin') {
							sessionStorage.setItem("name", data.personalAccount.name);
							sessionStorage.setItem("loginType", data.loginType);
							sessionStorage.setItem("ticketuserid", data.personalAccount.personalid);
							if(that.to == 'my') {
								sessionStorage.removeItem('holder')
								sessionStorage.removeItem('tcid')
								that.$router.push({
									name: 'TicketReservation'
								});
							} else {
								that.$router.push({
									name: 'PersonalCenter'
								});
							}
						} else if(data.loginType == 'teamLogin') {
							sessionStorage.setItem("name", data.teamAccount.teamname);
							sessionStorage.setItem("teamtype", data.teamAccount.teamtype);
							sessionStorage.setItem("loginType", data.loginType);
							sessionStorage.setItem("ticketuserid", data.teamAccount.teamid);
							if(that.to == 'my') {
								sessionStorage.removeItem('holder')
								sessionStorage.removeItem('tcid')
								that.$router.push({
									name: 'TicketReservation'
								});
							} else {
								that.$router.push({
									name: 'TeamCenter'
								});
							}
						}
					} else if(data.code == 'A00004') {
						that.$router.push({
							name: 'CenterLand'
						});
					}
				}
			});
		}
	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/loading.vue